// [ bizSAFE | Internal Audit | OTE ] — top-right switch on Jobs, Quotations and Tracker. bizSAFE is always shown first;
// switching only filters what is already loaded (Jobs / Quotations) or loads Internal Audit data on first click
// (Tracker), so the bizSAFE view never loads anything extra. The OTE option appears only where a page passes `ote`
// (Jobs and Quotations — OTE is kept off the Tracker).
import React from 'react'

export default function ServiceSwitch({ value, onChange, ote = false }) {
  const opt = (v, label) => (
    <button key={v} onClick={() => onChange(v)}
      style={{ borderRadius: 0, border: 'none', padding: '7px 16px', fontSize: 13, fontWeight: value === v ? 600 : 400,
        background: value === v ? 'var(--brand)' : 'var(--bg)', color: value === v ? '#fff' : 'var(--text2)', cursor: 'pointer' }}>
      {label}
    </button>
  )
  const divider = (k) => <span key={k} style={{ width: 1, background: 'var(--border2)' }} />
  return (
    <div style={{ display: 'inline-flex', border: '1px solid var(--border2)', borderRadius: 8, overflow: 'hidden' }}>
      {opt('biz', 'bizSAFE')}
      {divider('d1')}
      {opt('ia', 'Internal Audit')}
      {ote && divider('d2')}
      {ote && opt('ote', 'OTE')}
    </div>
  )
}
